import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormControl, TextField } from 'components'

const CommentPreview = ({
    isDisabled,
    defaultValue,
    onChange,
    ...props
}) => {

    const [value, setValue] = useState(defaultValue);

    const handleChange = (event) => {
        onChange(event.target.value);
        setValue(event.target.value);
    };

    return (
        <FormControl fullWidth>
            <TextField
                fullWidth
                multiline
                disabled={isDisabled}
                value={value}
                onChange={handleChange}
                { ...props }
            />
        </FormControl>
    );
};

CommentPreview.propTypes = {
    isDisabled: PropTypes.bool,
    defaultValue: PropTypes.string,
    onChange: PropTypes.func
};

CommentPreview.defaultProps = {
    isDisabled: false,
    defaultValue: '',
    onChange: () => {}
};

export default CommentPreview;
